module.exports = __webpack_public_path__ + "img/11.59e352a6.jpg";